import React, { useState } from 'react'
import { Controller, Control } from 'react-hook-form'
import { SketchPicker, ColorResult } from 'react-color'
import { InputLabel } from '@mui/material'

type Props = {
  control: Control<any>
  name: string
  label?: string
  disabled?: boolean
}

const ColorPickerInput: React.FC<Props> = ({ control, name, label, disabled }) => {
  const [open, setOpen] = useState(false)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const hex = typeof field.value === 'string' && field.value ? field.value : '#000000'
        const handleChange = (c: ColorResult) => field.onChange(c.hex)

        return (
          <div className="relative">
            {label && (
              <InputLabel shrink>{label}</InputLabel>
            )}

            <div className="flex items-center gap-3">
              <button
                type="button"
                disabled={disabled}
                onClick={() => setOpen((v) => !v)}
                className={[
                  'p-1 rounded border border-gray-200 bg-white shadow-sm',
                  'hover:shadow focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1',
                  disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
                ].join(' ')}
                aria-label="Choisir une couleur"
              >
                <span
                  className="block rounded"
                  style={{ width: 31, height: 33, background: hex }}
                />
              </button>

              <span className="text-sm text-gray-600 font-mono select-all">{hex}</span>

              <button
                type="button"
                onClick={() => field.onChange('#000000')}
                className="text-xs px-2 py-1 rounded border border-gray-200 text-gray-600 hover:bg-gray-50"
              >
                Reset
              </button>
            </div>

            {open && (
              <>
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setOpen(false)}
                />
                <div className="absolute z-50 bottom-full mb-2">
                  <SketchPicker color={hex} onChange={handleChange} />
                </div>
              </>
            )}

            {fieldState.error && (
              <p className="mt-1 text-sm text-red-600">{fieldState.error.message}</p>
            )}
          </div>
        )
      }}
    />
  )
}

export default ColorPickerInput
